import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const ProektirovanieProjects = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        showMore(event){
            let btn = $(event.target),
                list = $(this.$el).find('.js-projects-list');

            if (!btn.hasClass('is-show')) {
                btn.addClass('is-show');
                btn.text('Свернуть');
              list.addClass('is-show');
            } else {
                btn.removeClass('is-show');
                btn.text('Показать ещё');
              list.removeClass('is-show');
              $('html').animate({
                scrollTop: list.offset().top - 150
              }, 500);
            }
        }
    },
    updated(){

    },
    mounted(){

        if ($(this.$el).find('.js-project-item').length > 6) {
            $(this.$el).find('.js-projects-show').addClass('is-active');
        } else {
            $(this.$el).find('.js-projects-show').removeClass('is-active');
        }

        let figure = $(this.$el).find(".js-project-item").hover(hoverVideo, hideVideo);

        function hoverVideo(e) {
            if($('video', this).length)
                $('video', this).get(0).play();
        }

        function hideVideo(e) {
            if($('video', this).length)
                $('video', this).get(0).pause();
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="Object.keys(this.struct[this.structKey].componentData.ITEMS).length" class="section section--gray">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
                    Реализованные нами проекты
                </h2>
            </div>
        <a href="/vypolnennye-proekty/" class="btn btn--border projects__all-link">Все проекты</a>
        </div>
        <div class="brand__projects">
            <div class="brand__projects-list js-projects-list">

                <a  v-for="item in this.struct[this.structKey].componentData.ITEMS"
                    :key="item.ID"
                    :href="item.LINK"
                    class="projects__item js-project-item">
                    <div class="projects__item-img">
                        <img v-if="item.CARD_TYPE == 'photo'" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PREVIEW" :alt="item.NAME" :title="item.NAME">
                        <video v-if="item.CARD_TYPE == 'video'" preload="metadata" playsinline="" webkit-playsinline="" loop="" muted="">
                            <source :src="item.PREVIEW" :type="item.FILE_TYPE">
                        </video>
                    </div>
                    <div class="projects__item-top">
                        <div v-if="item.TYPE" class="projects__item-tag">
                            {{item.TYPE}}
                        </div>
                        <div class="projects__item-title">
                            {{item.NAME}}
                            <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                        </div>
                        <div class="projects__item-date">
                            {{item.YEAR}}
                        </div>
                    </div>
                    <div v-if="item.CARD_TYPE == 'photo'" class="projects__item-icon">
                        <svg class="ico ico-foto" width="13" height="13" aria-hidden="true"><use xlink:href="#ico-foto"></use></svg>
                        {{item.GALLERY_COUNT}}
                    </div>
                    <div v-if="item.CARD_TYPE == 'video'" class="projects__item-icon">
                        <svg class="ico ico-play" width="17" height="18" aria-hidden="true"><use xlink:href="#ico-play"></use></svg>
                    </div>
                </a>
            </div>
            <a href="#" @click.prevent="this.showMore($event)" class="btn btn--border js-projects-show">
                Показать ещё
            </a>
        </div>
    </div>
</section>
    `
}